import { Icon, SearchInput as Input, Button, VStack, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React from 'react';

import type { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';
import { useRedeemDetailsContext } from '../../contexts/redeem-details';
import { useRedeemOffersContext } from '../../contexts/redeem-offers';

interface RedeemActionsProps {}

export const RedeemActions: React.FC<RedeemActionsProps> = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const {
    handleSearchRedeemOffers,
    searchTermRedeemOffers,
    handleClearSearchRedeemOffers,
    isLoadingRedeemOffers,
    redeemOffersData,
  } = useRedeemOffersContext();
  const { redeemOffersStatus } = useRedeemDetailsContext();

  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const handleNavigateToRedeemDetailsFilter = () => {
    navigate('RedeemBatchTicketDetailsFilter');
  };

  return (
    <HStack
      alignItems="center"
      justifyContent="space-between"
      w="full"
      space={Spacing['inline.xxxs']}
      px={{ sm: Spacing['stack.xxs'] }}>
      <VStack flex={1}>
        <Input
          onSearch={handleSearchRedeemOffers}
          onClear={handleClearSearchRedeemOffers}
          initialSearch={searchTermRedeemOffers}
          placeholder="Pesquise por nome ou conta"
          isMobile={isMobile}
          isLoading={isLoadingRedeemOffers || redeemOffersData.length === 0}
        />
      </VStack>
      {redeemOffersStatus === 'sent' && (
        <Button
          variant="secondary"
          isDisabled={isLoadingRedeemOffers}
          _text={{
            fontWeight: Typography['fontweight.semibold'],
            color: Color['neutral.darkest'],
          }}
          onPress={handleNavigateToRedeemDetailsFilter}
          {...(!isMobile && { rightIcon: <Icon name="Funnel" size="xxxs" /> })}>
          Filtrar
        </Button>
      )}
    </HStack>
  );
};
